import { useQuery } from 'react-query';
import { fetchLiquidityPositions } from '~/api/bankAccounts';

export const useFetchLiquidityPositions = (enabled?: boolean) => {
  return useQuery('bank/accounts', fetchLiquidityPositions, {
    enabled,
  });
};
